<template>
  <v-container id="kidDetailOverview" class="pa-0" fluid>
    <v-row>
      <GoToBanner path="ParentDashboard" class="mt-8"/>
    </v-row>
    <v-row>
      <NameInfoBanner :name="kid.name" :avatar="kid.avatar" :points="kid.points" />
    </v-row>
    <v-row>
      <KidInfoTabs />
    </v-row>
  </v-container>
</template>

<script>
  import GoToBanner from "@/components/GoToBanner";
  import NameInfoBanner from "./NameInfoBanner";
  import KidInfoTabs from "./KidInfoTabs";

  export default {
    name: "KidDetailOverview",
    data() {
      return {
        kid: {},
      };
    },

    methods: {
      fetchChild() {
        this.$store.commit("setLoadingStatus", true);
        this.$http
          .get(`/children/${this.$route.params.id}`)
          .then((response) => {
            this.kid = response.data.child;

            this.$store.commit("setLoadingStatus", false);
          })
          .catch(() => {
            this.$store.commit("setError", {
              message: "Failed to Fetch kid information",
              type: "error",
            });
            this.$store.commit("setLoadingStatus", false);
          });
      },
    },

    created() {
      this.fetchChild();
    },

    components: {
      GoToBanner,
      NameInfoBanner,
      KidInfoTabs,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidDetailOverview.vue